import { FC } from 'react';

import { PlayIconType } from '@gem/ui-kit';

import { AudioState } from 'APP/main/components/AudioState/AudioState';

import { AllDownloadsItemInfo } from '../AllDownloadsItemInfo/AllDownloadsItemInfo';

export interface IAllDownloadsAudioItemProps {
  className?: string;
  payloadId: string;
  groupId: string;
  messageId: string;
}

export const AllDownloadsAudioItem: FC<IAllDownloadsAudioItemProps> = (props) => {
  const { className, payloadId, groupId, messageId } = props;

  return (
    <div className={className}>
      <AudioState
        groupId={groupId}
        messageId={messageId}
        payloadId={payloadId}
        iconType={PlayIconType.Play}
      />
      <AllDownloadsItemInfo
        payloadId={payloadId}
        groupId={groupId}
        messageId={messageId}
      />
    </div>
  );
};
